export default "__VITE_ASSET__BSJGXkC1__"